module.exports = __webpack_public_path__ + "static/media/icon-google-black.78827d1a.svg";